import React from 'react';
import { Route, Navigate, useLocation } from 'react-router-dom';
import { usePageStatus } from '../contexts/SiteSettingsContext';
import StatusPage from './StatusPage';

/**
 * Wrap a public route with page-visibility logic. If the page is:
 *   - published        → render children normally
 *   - hidden           → redirect to home (page unreachable)
 *   - coming_soon      → render branded Coming Soon page
 *   - under_construction → render branded Under Construction page
 *
 * Admins can bypass the guard by appending ?preview=1 to the URL
 * (draft preview support — used later in Stage 2B).
 */
const PublicRouteGuard = ({ pageKey, children }) => {
  const status = usePageStatus(pageKey);
  const location = useLocation();
  const previewMode = new URLSearchParams(location.search).get('preview') === '1';

  if (previewMode) return children;

  switch (status.status) {
    case 'hidden':
      return <Navigate to="/" replace />;
    case 'coming_soon':
      return <StatusPage page={status} kind="coming_soon" />;
    case 'under_construction':
      return <StatusPage page={status} kind="under_construction" />;
    case 'published':
    default:
      return children;
  }
};

export default PublicRouteGuard;
